import { Clear } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Input, styled } from '@mui/material';

export const StyledSearchBar = styled(Box)`
    height: 50px;
    min-width: 275px;
    border-radius: ${({ theme }) => theme.shape.borderRadiusLarge}px;
    background-color: rgba(255, 255, 255, 0.1);
    padding: 13px 10px 13px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledSearchInput = styled(Input)`
    border: 0;
    color: ${({ theme }) => theme.palette.primary.contrastText};
    ::before,
    ::after {
        content: initial;
    }
    width: 100%;
`;

export const StylesClearButton = styled(Button)`
    color: white;
    padding: 5px;
    min-width: 0;
    border-radius: 50px;
`;

export const StyledClearIcon = styled(Clear)`
    width: 15px;
    height: 15px;
`;

export const StyledSearchIcon = styled(SearchIcon)`
    width: 24px;
    height: 24px;
    color: #ffffff;
`;
